import Vue from 'vue';

export default Vue.component('ed-progress', {
  name: 'ed-progress',
  props: ['title', 'description', 'progress','background', 'showPercent'],
  data: () => {
    return {
      defaultBackground: 'var(--ed-color-green)'
    }
  },
  computed: {
    backgroundProgress(){
      return this.background? this.background: this.defaultBackground;
    },
    progressRound(){
      return Math.floor(this.progress);
    }
  }
});